import ApiClient from "../../_config/client";

export const getSummaryRequest = (stepNumber) =>
  ApiClient.get("/summary/" + stepNumber);
